import styled from "@emotion/styled";
import React, { AnchorHTMLAttributes, forwardRef } from "react";

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
  testId?: string;
};

const StyledLink = styled.a`
  color: #E52581;
  text-decoration-line: underline;
  outline: 0;
  border-radius: .125rem;

  & * {
    color: inherit;
    font-size: inherit;
  }

  &:focus {
    box-shadow: 0 0 0 .25rem #F2D0E2;
  }
`;

const Link = forwardRef<HTMLAnchorElement, Props>((props: Props, ref) => {
  const { testId, ...linkProps } = props;

  return (
    <StyledLink ref={ref} data-testid={testId} {...linkProps} />
  );
});

export default Link;
